import { render } from "./VCounter.vue?vue&type=template&id=78019206"
import script from "./VCounter.vue?vue&type=script&lang=js"
export * from "./VCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__